import React, { useEffect, useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import "./css/Slider.css";

function Slider() {
  const [slides, setSlides] = useState([]);

  useEffect(() => {
    fetch(
      "https://yaasaai.com/myphpapi/get_slider_images.php?action=get-slider-images"
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setSlides(data.data);
        } else {
          console.error(
            "Failed to load slides:",
            data.error || "Unknown error"
          );
        }
      })
      .catch((err) => console.error("Slider fetch error:", err));
  }, []);

  return (
    <Carousel data-bs-theme="white">
      {slides.map((slide, index) => (
        <Carousel.Item key={index}>
          <img
            className="d-block w-100"
            src={slide.image_url}
            alt={`Slide ${index + 1}`}
          />
          {slide.caption && <Carousel.Caption></Carousel.Caption>}
        </Carousel.Item>
      ))}
    </Carousel>
  );
}

export default Slider;
